import { useState, useEffect } from "react";
import api from "../../../../utils/api";

const useLogin = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const savedUsername = localStorage.getItem("savedUsername");
    const rememberMeFlag = localStorage.getItem("rememberMe");
    if (rememberMeFlag === "true" && savedUsername) {
      setUsername(savedUsername);
      setRememberMe(true);
    }
  }, []);

  const handleLogin = async () => {
    setIsLoading(true);
    setError("");
    try {
      const response = await api.post("/auth/login", { username, password });

      if (response.data.token) {
        const { token, username: loggedInUser, role, mustChangePassword } = response.data;

        localStorage.setItem("token", token);
        localStorage.setItem("username", loggedInUser);
        localStorage.setItem("role", role);
        localStorage.setItem("userId", response.data.userId);

        if (mustChangePassword) {
          localStorage.setItem("mustChangePassword", "true");
        } else {
          localStorage.removeItem("mustChangePassword");
        }

        if (rememberMe) {
          localStorage.setItem("rememberMe", "true");
          localStorage.setItem("savedUsername", loggedInUser);
        } else {
          localStorage.removeItem("rememberMe");
          localStorage.removeItem("savedUsername");
        }

        onLoginSuccess(token);
      }
    } catch {
      setError("Invalid username or password");
    } finally {
      setIsLoading(false);
    }
  };

  const handleForgotPassword = () => {
    alert("Please contact your administrator to reset your password.");
  };

  return {
    username, setUsername,
    password, setPassword,
    rememberMe, setRememberMe,
    error,
    showPassword, setShowPassword,
    isLoading,
    handleLogin,
    handleForgotPassword,
  };
};

export default useLogin;
